import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { FilterService } from 'common/service/filter/service';
import { SaveSearchStoreService } from 'common/service/save-search-store/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';

import { SaveSearchTrackerFactory } from '../tracker.factory';
import { SaveSearchFormViewStore } from './view-store';

export function SaveSearchFormViewStoreFactory(): SaveSearchFormViewStore {
  return new SaveSearchFormViewStore(
    EventEmitterFactory(),
    SaveSearchStoreService(),
    FilterService(),
    SaveSearchTrackerFactory(),
    UserAuthenticationService()
  );
}
